import {
  Component,
  EventEmitter,
  Inject,
  Input,
  Output,
  OnChanges,
  SimpleChanges
} from '@angular/core';
import {
  PrivilegeEnum,
  StudentBasicResponseDto,
  StudentPerformanceDto,
  ValidationUtil
} from '@whetstoneeducation/hero-common';
import { Router } from '@angular/router';
import { logger } from '../logger';
import { AppToastManagerService } from '../services/toast-manager.service';
import { BaseComponent } from '../base-classes/base.component';

@Component({
  selector: 'app-student-card',
  templateUrl: './student-card.template.html',
  styleUrls: ['./student-card.scss']
})
export class AppStudentCardComponent extends BaseComponent implements OnChanges {
  @Input() student: StudentPerformanceDto;
  @Input() studentSelected: boolean;
  @Input() selectStudent: EventEmitter<number>;

  defaultImage: string = 'assets/img/ghost-user-icon.png';
  selectedImage: string | ArrayBuffer | null = this.defaultImage;

  constructor(
    public router: Router,
    @Inject(AppToastManagerService)
    private toastService: AppToastManagerService
  ) {
    super();
  }

  onImgError() {
    this.selectedImage = this.defaultImage;
  }

  // Cards are reused as the list grows, so the photo has to follow the bound student
  // instead of sticking with whatever was resolved when the card was created.
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['student']) {
      this.selectedImage =
        this.student?.profilePhotoUrl ?? this.defaultImage;
    }
  }

  toggleStudentSelection(studentId: number): void {
    const { privileges, currentSchoolId } =
      this.StorageManager.getLoggedInUser();
    if (
      ValidationUtil.hasPrivilege(
        PrivilegeEnum.TRACK_BEHAVIOR,
        privileges,
        currentSchoolId
      )
    ) {
      this.selectStudent.emit(studentId);
    }
  }

  viewStudentProfile(studentId: number): void {
    const url = this.router.serializeUrl(
      this.router.createUrlTree([`/students/${studentId}/profile`])
    );
    // open student profile in new tab
    // instead of using the same tab
    const newTab = window.open(url, '_blank');
    if (!newTab || newTab.closed || typeof newTab.closed == 'undefined') {
      // new tab was blocked
      logger.error('New tab was blocked');
      this.toastService.warn(
        'New tab was blocked, to open student profile in a new tab please allow popups for this site. Navigation should proceed in 3 seconds.'
      );
      setTimeout(() => {
        this.router.navigate([`/students/${studentId}/profile`]);
      }, 3000);
    }
  }
}
